WB.App.filter('UnitsFilter', function()
{
    return function (input, UnitUtility)
    {
        if (input != undefined)
        {
            return input.replace(/((?=.)(\d{1,3})(\.\d+)?) (mph|kph|km\/h|m\/s|kts)/g, function ($1, $2, $3, $4, $5)
            {
                var windValue;
                if ($5 == 'mph')
                {
                    windValue = $2;
                }

                if ($5 == 'kph')
                {
                    windValue = UnitUtility.convertWindKmM(Number($2));
                }

                return UnitUtility.convertWindUnits(Number(windValue));
            });
        }
    };
});
